var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:_vm.$style.formButtonsParentContainer},[_c('div',{class:_vm.$style.formButtonsLeftContainer},[_vm._t("left")],2),_c('div',{class:_vm.$style.formButtonsRightContainer},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }